import api from './index';

const TerritoryAPI = {
  getTerritories: async () => api.get('/territory'),
};

export default TerritoryAPI;
